import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./ui/App";
import "./styles/app.css";

const root = document.getElementById("root");

if (root === null) {
  throw new Error("Could not find the #root element required to start the application.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
